import { axiosClient } from '../../../services/axiosInstance'
import { logEvent } from './log'
import { initialize } from './init'
import { getApiKey } from '../core/initialize'
import { getStatsigUserId } from '../session/session'

export const USER_ID = getStatsigUserId()
export const ENVIRONMENT = {
  production: { tier: 'production' },
  staging: { tier: 'staging' },
  development: { tier: 'development' },
}

export function postToStatsig(path: string, data: any) {
  const timestamp = Date.now()
  const statsigApiKey = getApiKey()

  const headers = {
    'statsig-api-key': statsigApiKey ?? '',
    'Content-Type': 'application/json',
    'STATSIG-CLIENT-TIME': timestamp,
  }

  return axiosClient.post(`https://events.statsigapi.net${path}`, data, {
    headers,
  })
}

export const statsigClient = {
  initialize,
  logEvent,
}
